import script from "./QGMap.vue?vue&type=script&setup=true&lang=js"
export * from "./QGMap.vue?vue&type=script&setup=true&lang=js"

import "./QGMap.vue?vue&type=style&index=0&id=227ea9e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-227ea9e0"]])

export default __exports__